var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDate = function SvgDate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M22.333 28.852C24.191 25.964 26.878 24 29.998 24s5.806 1.964 7.664 4.852c1.865 2.899 2.986 6.843 2.986 11.148s-1.121 8.25-2.986 11.148C35.804 54.036 33.118 56 29.998 56s-5.807-1.964-7.665-4.852c-1.865-2.899-2.985-6.843-2.985-11.148s1.12-8.25 2.985-11.148m1.682 1.082c-1.628 2.53-2.667 6.087-2.667 10.066s1.04 7.535 2.667 10.066C25.65 52.606 27.788 54 29.998 54s4.348-1.394 5.982-3.934c1.628-2.53 2.668-6.087 2.668-10.066s-1.04-7.535-2.668-10.066C34.346 27.394 32.207 26 29.998 26s-4.348 1.393-5.983 3.934",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M48.652 25a1 1 0 1 0-2 0v13.03a1 1 0 0 0 1 1h11V55a1 1 0 0 0 2 0V25a1 1 0 1 0-2 0v12.03h-10z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M10.395 10.688a1 1 0 0 1 1-1h58a1 1 0 0 1 1 1v58a1 1 0 0 1-1 1h-58a1 1 0 0 1-1-1zm2 1v56h56v-56z",
    clipRule: "evenodd"
  })));
};
export default SvgDate;